export default __webpack_public_path__ + "static/media/0x51de72b17c7bd12e9e6d69eb506a669eb6b5249e.933d042a.webp";